module.exports = __webpack_public_path__ + "img/category.60ef8194.svg";